// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-toolbar {\n  position: fixed;\n  transform: translateY(205px);\n  border: none !important;\n}\n\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 1px solid #ccc !important;\n}\n", ""]);
// Exports
module.exports = exports;
